<template>
  <div :class="['book', {'book_white': whiteBg}]">
    <div class="book__panel">
      <a class="book__logo" href="#">
        <inline-svg
          class="book__kodland"
          :src="require('@/assets/svg/kodland-logo.svg')"
          alt="kodland"/>
      </a>
      <a v-if="isBackButton" href="#" class="book__go-back">
        <inline-svg class="book__arrow" :src="require(`@/assets/svg/arrow.svg`)"/> 
        Назад
      </a>
    </div>
    <slot />
    <img class="book__lines" src="@/assets/img/book_bg.png">  
  </div>
</template>

<script>
export default {
  props: {
    isBackButton: {
      type: Boolean,
      required: false
    },
    whiteBg: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped> 
.book {
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  padding-bottom: 200px;
  @media(max-width: 767px) {
    padding-bottom: 150px;
  }
  background: linear-gradient(115.11deg, #12329C -2.18%, #3860ED 82.62%, #3860ED 82.62%);
  &_white::v-deep {
    background: #fff;
    & .book__kodland path {
      fill: var(--main-blue);
    }
    & .book__arrow path {
      stroke: var(--main-blue);
    }
    & .book__go-back {
      color: var(--main-blue);
    }
    & .book__lines {
      display: none;
    }
  }
  &__lines {
    max-width: 538px;
    position: absolute;
    bottom: 0;
    @media(max-width: 767px) {
      max-width: 350px;
    }
    @media(max-width: 375px) {
      display: none;
    }
  }
  &__panel {
    padding: 40px 0 0 40px;
    margin-bottom: 45px;
    @media(max-width: 767px) {
      padding: 40px 0 0 10px;
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 65px;
    }
  }
  &__logo {
    @media(max-width: 767px) {
      order: 2;
      position: absolute;
      left:50%;
      transform:translate(-50%);
    }
    &_static { 
      @media(max-width: 767px) {
        position: static;
        margin-bottom: 40px;
      }
    }
  }
  &__go-back {
    font-family: 'JetBrains Mono', monospace, sans-serif;
    display: flex;
    align-items: center;
    margin-top: 45px;
    color: #fff;
    @media(max-width: 767px) {
      margin-top: 0;
    }
  }
  &__arrow {
    margin-right: 10px;
  }
}
</style>